export * from './axios';
export * from './getIconByTypeNumber';
export * from './getKids';
export * from './productTypes';
export * from './getProductTypeName';
export * from './getPluralProductName';
export * from './getSingularProductName';
export * from './getWindowSize';
export * from './hexToRgb';
export * from './icons';
export * from './makeUrl';
export * from './objectIsEmpty';
export * from './removeObjectProperties';
export * from './reportToSegment';
export * from './startWithUpperCase';
export * from './storeParameters';
export * from './weatherIcons';
export * from './segmentEvents';
export * from './slugify';
export * from './getAmenityName';
export * from './getExperienceName';
export * from './getBookingStatus';
export * from './getCardBrandIcon';
export * from './getCategory';
export * from './getCanonicalHost';
